export class qPRequestModel {
    classId: number;
    userId: number;
    constructor(classId: number, userId: number) {
        this.classId = classId;
        this.userId = userId;
    }
}